import RailDetailWidget from "components/Widgets/RailDetailWidget";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routeSelected, setSelectedRailInspectionImage } from "redux/actions";
import _ from "lodash";
import RailInspectBigScroller from "components/display/image/RailInspectBigScroller";

const targetResourceSelector = (state) => state.targetResource;
const reduxSessionIDSelector = (state) => state.playlist.data.routeID;
const railDataObjectSelector = (state) => state.railInspection.railInspectionImages.data;
const fourFootImageryToggleSelector = (state) => state.railInspection.widgetFourFootDisplay;

const InspectionLayout = ({ measureRef }) => {
    const targetResource = useSelector(targetResourceSelector);
    const reduxSessionID = useSelector(reduxSessionIDSelector);
    const railData = useSelector(railDataObjectSelector);

    const fourFootImagery = useSelector(fourFootImageryToggleSelector);

    const dispatch = useDispatch();

    useEffect(() => {
        if (targetResource.session_id) {
            dispatch(routeSelected(targetResource.session_id, targetResource.image_timestamp));
        }
    }, [dispatch, targetResource]);

    useEffect(() => {
        if (railData && railData.length && targetResource.image_timestamp) {
            const imageIndex = _.findIndex(railData, { timestamp: targetResource.image_timestamp });
            if (imageIndex > -1) {
                dispatch(setSelectedRailInspectionImage(imageIndex, railData[imageIndex], null, 0.5));
            }
        }
    }, [dispatch, railData, targetResource]);

    const bigScrollerContent = useMemo(() => {
        if (fourFootImagery) {
            return (
                <RailInspectBigScroller
                    inPlayer
                    noNavButtons
                    noContent
                />
            );
        }

        return null;
    }, [fourFootImagery]);

    if (!targetResource.session_id && _.isEmpty(railData)) {
        return (
            <div className="InspectionLayout">
                <div className="NoDataContainer">
                    <span>No data found for requested position</span>
                </div>
            </div>
        );
    }

    return (
        <div className="InspectionLayout">
            <RailDetailWidget
                widgetPosition={false}
                _routeID={reduxSessionID}
                singleSource={true}
                navControls={true}
                isWidgetLayout={true}
            />
            {bigScrollerContent}
        </div>
    );
};

export default InspectionLayout;
